import { useState, useCallback } from "react";

interface IUseProgressProps {
  videoRef: React.RefObject<HTMLVideoElement>;
}

const SECONDS = 1000;
const STEP_RATE = 0.2;

export const useProgress = ({ videoRef }: IUseProgressProps) => {
  const [progress, setProgress] = useState<number>(0);
  const [playing, setPlaying] = useState<boolean>(true);
  const [duration, setDuration] = useState<number>(0);
  const [firstTimeEnded, setFirstTimeEnded] = useState(false);

  const handleSeekBarChange = (time: number): void => {
    if (Number.isFinite(time) && videoRef.current) {
      videoRef.current.currentTime = time / SECONDS;
    }

    setPlaying(false);
    setProgress(time);
  };

  const handleSeekBarChangeEnd = (): void => setPlaying(true);

  const handleTimeUpdate = useCallback((): void => {
    if (videoRef.current) {
      if (
        Math.abs(videoRef.current.currentTime - videoRef.current.duration) <= STEP_RATE &&
          !firstTimeEnded
      ) {
        setFirstTimeEnded(true);
      }
      setProgress(videoRef.current.currentTime * SECONDS);
    }
  }, [firstTimeEnded, videoRef]);

  const handleLoadedMetadata = useCallback((): void => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration * SECONDS);
    }
  }, [videoRef]);

  return {
    progress,
    playing,
    duration,
    firstTimeEnded,
    handleSeekBarChange,
    handleSeekBarChangeEnd,
    handleTimeUpdate,
    handleLoadedMetadata
  };
};
